/**
 * @fileoverview Helpers used for the yext.location.* pages
 * @author Dan Pomeroy <dp@yext.com>
 */
goog.provide('yext.location.helpers');


/**
 * Display mode message for when fields have various content
 */
yext.location.helpers.variousContentMessage = function() {
  return '<span class="various">&lt;' + yext.msg('Various content') + '&gt;</span>';
};

/**
 * Display mode message for when a field is empty
 * @param {boolean} cannotEdit
 */
yext.location.helpers.emptyFieldMessage = function(cannotEdit) {
  let msg = cannotEdit ? yext.msg('No value') : yext.msg('Click to add');
  return '<span class="emptyvalue">' + msg + '</span>';
};

/**
 * Error message
 * @param {string} message
 */
yext.location.helpers.errorMessage = function(message) {
  return '<span class="error">' + message + '</span>';
};

/**
 * Show errors next to fields
 *
 * @param {!Object} error Object with keys corresponding to input names
 * @param {!jQuery} $context The context in which to search for an error
 */
yext.location.helpers.showErrors = function(error, $context) {
  for (var key in error) {
    // NOTE(cbreezy): specific case fix for the pobox error which causes
    // all error messages to show up when triggered
    if (key == 'address.pobox') {
      $context.find('.field-generic-error').hide();
      $context.find('.pobox-error').show();
      continue;
    }

    if (key.startsWith('custom-field-')) {
      var id = key.split('-')[2];
      var $field = $context.find('[data-custom-field-id="' + id + '"]');
      var $error = $field.find('.js-field-error');
    } else {
      var $input = $context.find('[name^="' + key + '"]');
      var $error = yext.location.helpers.closestError($input);
    }

    if ($error.length) {
      $error.html(error[key]).show();
    } else {
      yext.location.helpers.showGenericError($input);
    }
  }
};

/**
 * Find closest error field given a context
 *
 * @param {!jQuery} $context The context in which to search for an error
 */
yext.location.helpers.closestError = function($context) {
  var $error = $context.siblings('.field-edit-form-errors');
  if (!$error.length) {
    $error = $context.closest('.js-text-field').find('.field-edit-form-errors');
  }
  if (!$error.length) {
    $error = $context.closest('.show-field-error').find('.field-edit-form-errors');
  }
  if (!$error.length) {
    var $inputContainer = $context.closest('.input-container:not(.js-struct-field)');
    $error = $inputContainer.siblings('.field-edit-form-errors');

    if (!$error.length) {
      $error = $inputContainer.find('.field-edit-form-errors');
    }
  }

  return $error;
};

/**
 * Finds the closest generic error and shows it
 * @param {!jQuery} $context The context used to search for the error
 */
yext.location.helpers.showGenericError = function($context) {
  $context.closest('.field-edit-inner').find('.field-generic-error').show();
};


/**
 * Hides all the form errors on the page
 * @param {!jQuery} $context The context in which to search for an error
 */
yext.location.helpers.hideAllErrors = function($context) {
  $context.find('.js-field-error, .field-generic-error, .field-edit-form-errors, .pobox-error').hide();
};

/**
 * Show error on field
 *
 * @param {string} value Error string
 * @param {!jQuery} $context The context to search for the error element
 */
yext.location.helpers.showError = function(value, $context) {
  $context.find('.js-field-error').first().html(value).show();
};

/**
 * Show stale error on field
 *
 * @param {!jQuery} $context The context to search for the error element
 */
yext.location.helpers.showStaleError = function($context) {
  yext.location.helpers.showError(yext.location.helpers.staleErrorMessage, $context);
};

/**
 * Hide an error
 *
 * @param {!jQuery} $context The context to search for the error element
 */
yext.location.helpers.hideError = function($context) {
  $context.find('.js-field-error').hide();
};

/**
 * Create a changed input
 *
 * @param {string} name Name of changed field
 * @return {!jQuery} Hidden input element
 */
yext.location.helpers.createChangedInput = function(name) {
  return $('<input/>', {
    'class': 'js-changed-input',
    'name': name + 'Changed',
    'value': 'true',
    'type': 'hidden',
  });
};

/**
 * Remove changed inputs after a save or a reset
 *
 * @param {!jQuery} $context A context to search for changed inputs
 */
yext.location.helpers.removeChangedInputs = function($context) {
  $context.find('.js-changed-input').remove();
};

/**
 * A fall back image for when things don't want to load.
 *
 * @param {function()} cb On load/error callback
 */
yext.location.helpers.fallbackImage = function(cb) {
  var img = new Image();
  img.onload = function() {
    cb(this);
  };
  img.onerror = function() {
    cb(this);
  };
  img.src = '/s/public/images/photo-placeholder-160x120.png';
};

yext.location.helpers.staleErrorMessage = yext.msg('Your changes could not be made because another user edited this field since you loaded this page. Please try again.');

/**
 * Prepend http:// to a url if it does not have one
 *
 * @param {string} url
 */
yext.location.helpers.preprendProtocol = (function() {
  var STARTS_WITH_HTTP = /^http/;
  return function(url) {
    if (!STARTS_WITH_HTTP.test(url)) {
      url = 'http://' + url;
    }
    return url;
  };
})();

/**
 * Escape an input field to prevent injected JavaScript from executing
 *
 * @param {string} input
 * @return {string} escaped html
 * @author Brian Lin <blin@yext.com>
 */
yext.location.helpers.escapeInput = function(input) {
  return $('<div/>').text(input).html();
};
